import Vue from 'vue'
import VueRouter from 'vue-router'
import shareRoute from "@/share_route/context/views/ShareRoutes.vue";
import ServiceResume from "@/share_route/context/views/ServiceResume.vue";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Ruta',
    component: shareRoute
  },
  {
    path: '/resume',
    name: 'Resume',
    component: ServiceResume
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
